module.exports = __webpack_public_path__ + "img/ic_bed_sandh_4.d9a4b8cb.png";